import { render, staticRenderFns } from "./OverlayBox.vue?vue&type=template&id=dc546ee4&scoped=true"
import script from "./OverlayBox.vue?vue&type=script&lang=js"
export * from "./OverlayBox.vue?vue&type=script&lang=js"
import style0 from "./OverlayBox.vue?vue&type=style&index=0&id=dc546ee4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc546ee4",
  null
  
)

export default component.exports